import React from 'react';

export const initSessionContext = {
    sessionLoaded: false,
    session: {},
};

export const SessionContext = React.createContext(initSessionContext);
export const SessionProvider = SessionContext.Provider;
export const SessionConsumer = SessionContext.Consumer;